import styled from "styled-components";

export const NewRoleWrap = styled.div`
  .user-fields {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    margin-bottom: 20px;
    @media (min-width: 768px) {
      gap: 20px;
      grid-template-columns: repeat(2, 1fr);
    }
  }
  .permissions {
    cursor: pointer;
    border-bottom: 1px solid #d1d1d1;
    color: ${({ theme }) => theme?.light?.primary};
    display: flex;
    align-items: end;
    justify-content: end;
    gap: 10px;
    padding-bottom: 20px;
    margin-bottom: 30px;
    span {
      font-size: 18px;
      line-height: 22px;
    }
  }
  .btn-holder {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
